import { React, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { formatPhoneNumber } from '../../../Utils/phoneUtils';
import { useTheme } from '../../../Context/ThemeContext';
import { useLanguage } from '../../../Context/LanguageContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import { ReactComponent as DeleteSvg } from '../../../image/Delete.svg';
import UserProfile from '../../../Component/Normal/UserProfile';

const CoachSettingInfoBox = (props) => {
  const { data, index, modifyClickFn, deleteClickFn } = props;
  const { isDark } = useTheme();
  const { t, languageMode } = useLanguage();
  const theme = isDark ? darkTheme : lightTheme;

  const [userId, setUserId] = useState();

  const ModifyButtonRef = useRef();
  const DeleteButtonRef = useRef();

  useEffect(() => {
    let userIdList = data.linkCoachId.split('@');

    if (userIdList[0].includes('kakao.')) setUserId(userIdList[0].replaceAll('kakao.', '') + '@' + userIdList[1]);
    else if (userIdList[0].includes('naver.')) setUserId(userIdList[0].replaceAll('naver.', '') + '@' + userIdList[1]);
    else if (userIdList[0].includes('google.')) setUserId(userIdList[0].replaceAll('google.', '') + '@' + userIdList[1]);
    else if (userIdList[0].includes('apple.')) setUserId(userIdList[0].replaceAll('apple.', '') + '@' + userIdList[1]);
    else setUserId(data.linkCoachId);
  }, [])

  function onClickInfoBox(e) {
    if (DeleteButtonRef.current.contains(e.target)) deleteClickFn(index);
    else modifyClickFn(index);
  }

  return (
    <TopLevelWrapper>
      <ImageWrapper>
        <UserProfile profile={data.profile} defaultProfile='https://picture.link-zone.org/ZoneLogo.png' />
      </ImageWrapper>
      <InfoBox $isDark={isDark} onClick={onClickInfoBox}>
        <TopColumnWrapper>
          {/* <ButtonWrapper>
            </ButtonWrapper> */}
          <DeleteBoxWrapper>
            <DeleteBox ref={DeleteButtonRef}>
              <StyledDeleteIcon />
            </DeleteBox>
          </DeleteBoxWrapper>
        </TopColumnWrapper>
        <InnerInfoBox>
          <TitleWrapper>
            <NameWrapper>
              <Name>{data.name}</Name>
            </NameWrapper>
            <Title>{t('settingCoach.coach')}</Title>
          </TitleWrapper>
          <TotalInfoWrapper>
            <InfoTitleWrapper>
              <Column>{t('settingCoach.gender')}</Column>
              {/* <Column>이메일</Column> */}
              <Column>{t('settingCoach.phone')}</Column>
              <Column>{t('settingCoach.linkoId')}</Column>
            </InfoTitleWrapper>
            <InfoContentWrapper>
              <Info>{data.gender === 'Male' ? t('settingCoach.male') : t('settingCoach.female')}</Info>
              {/* <Info>{data.email}</Info> */}
              <Info>{formatPhoneNumber(data.phone, data.countryCode, languageMode)}</Info>
              <Info>{userId}</Info>
            </InfoContentWrapper>
          </TotalInfoWrapper>
          <AuthBoxWrapper>
            {
              data.isMemberAuth &&
              <AuthBox backgroundColor={theme.category2}>
                <Text style={{ marginTop: '-2px' }} fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.background}>{t('settingCoach.memberAuth')}</Text>
              </AuthBox>
            }
            {
              data.isExerciseAuth &&
              <AuthBox backgroundColor={theme.category1}>
                <Text style={{ marginTop: '-2px' }} fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.background}>{t('settingCoach.exerciseAuth')}</Text>
              </AuthBox>
            }
            {
              data.isSalesAuth &&
              <AuthBox backgroundColor={theme.category3}>
                <Text style={{ marginTop: '-2px' }} fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.background}>{t('settingCoach.salesAuth')}</Text>
              </AuthBox>
            }
          </AuthBoxWrapper>
        </InnerInfoBox>
      </InfoBox>
    </TopLevelWrapper>
  )
}

export default CoachSettingInfoBox;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 16px;
`;

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 199px;
  height: 199px;

  overflow: hidden;

  border-radius: 24px;
  // filter: drop-shadow(0px 40px 50px rgba(240, 232, 227, 0.5));
  background-color: ${props => props.theme.subBackground};

  img {
    object-fit: cover;
  }
`;

const ImageView = styled.img`
  width: 199px;
  height: 199px;

  border-radius: 24px;

  object-fit: cover;
  // object-fit: contain;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 278px;
  height: 197px;

  border: 1px solid ${props => props.theme.subBackground};
  border-radius: 15px;
  box-shadow: ${props => props.theme.shadowLarge};
  background-color: ${props => props.theme.subBackground};

  // overflow: hidden;

  transition: all 0.3s ease-in-out;

  @media (hover: hover){
    &:hover {
    cursor: pointer;
    border: 1px solid ${props => props.theme.primary};
    }
  }
`;

const DeleteBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-end;

  margin-top: -1px;
  margin-right: -1px;
`;

const DeleteBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 37px;
  height: 37px;

  border-radius: 0px 15px 0px 5px;
  background-color: ${props => props.theme.pointRed}33;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      background-color: ${props => props.theme.pointRed};
    }
  }
`;

const StyledDeleteIcon = styled(DeleteSvg)`
  width: 20px;
  height: 20px;

  color: ${props => props.theme.subBackground};
`;

const InnerInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 80%;
  height: 150px;
`;

const TopColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  // width: 80%;
  width: 100%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  gap: 4px;
`;

const NameWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  max-width: 100%;
  height: 23px;

  overflow: hidden;
`;

const Name = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Title = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 16px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;

  white-space: nowrap;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const Button = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;

  transition: all 0.3s ease-in-out;
`;

const TotalInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 10px;
`;

const InfoTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  margin-top: 8px;

  width: 72px;
  flex-shrink: 0;

  gap: 8px;
`;

const InfoContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  margin-top: 8px;

  flex: 1;
  min-width: 0;

  gap: 8px;

  overflow: hidden;
`;

const Column = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;

const Info = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;

  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const AuthBoxWrapper = styled.div`
  display: flex;
  flex-direcrtion: row;

  // justify-content: space-between;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;

  margin-top: 12px;

  width: 100%;

  gap: 8px;
`;

const AuthBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0 8px;
  height: 20px;

  border-radius: 5px;
  background-color: ${props => props.backgroundColor};
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
`;
